<template>
  <div>
    <div class="pageMain" :class="(globalDataArray.siteInfo && globalDataArray.siteInfo.greyOut == 1) ? 'bigEventGray' : ''">
      <div class="banner perBan">
        <img :src="banners.image || ''" alt="">
        <div class="w1440">
          <div class="txt">
            <div class="fnt_52">
              {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.banner_welcome) || '欢迎' }}

              <template v-if="saitiAccessInfo && saitiAccessInfo.nickname && saitiAccessInfo.nickname!='' && saitiAccessInfo.nickname!=null && saitiAccessInfo.nickname!=undefined">
                {{ saitiAccessInfo.nickname }}
              </template>

              <template v-else-if="saitiAccessInfo && saitiAccessInfo.username && saitiAccessInfo.username!='' && saitiAccessInfo.username!=null && saitiAccessInfo.username!=undefined">
                {{ saitiAccessInfo.username }}
              </template>
            </div>
            <div class="fnt_18 mail" v-if="saitiAccessInfo && saitiAccessInfo.email && saitiAccessInfo.email!='' && saitiAccessInfo.email!=null && saitiAccessInfo.email!=undefined">
              {{ saitiAccessInfo.email }}
            </div>
            <div class="fnt_18" v-else-if="saitiAccessInfo && saitiAccessInfo.phone && saitiAccessInfo.phone!='' && saitiAccessInfo.phone!=null && saitiAccessInfo.phone!=undefined">
              {{ saitiAccessInfo.phone }}
            </div>
          </div>
        </div>
      </div>

      <div class="personPage">
        <div class="cf w1440">
          <div class="personLeft">
            <personmenu />
          </div>

          <div class="personRight">
            <div class="tit fnt_32">{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.person_signup_record) || '报名记录' }}</div>

            <div class="antDesignTable">
              <a-table
                row-key="id"
                :scroll="{x:true}"
                :columns="columns"
                :data-source="list"
                :pagination="paginationOpt"
                class="j-table-force-nowrap"
              >
                <template slot="tit" slot-scope="text, record">
                  <router-link
                    target="_blank"
                    v-if="record.competitionDelflag=='0' && record.competitionStatus=='1'"
                    :to="{
                      path: '/competitionInfo',
                      query: {
                        id: record.competitionParentId,
                        checkStatus: record.checkStatus
                      }
                    }"
                    class="compNameBtn title_first"
                    :title="text"
                  >
                    {{ text }}
                  </router-link>
                  <span :title="text" v-else class="compNameBtn title_first" @click="delCancel(record)">{{ text }}</span>
                </template>

                <template slot="curstatus" slot-scope="text, record">
                  <template v-if="record.competitionDelflag=='1'">
                    {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.has_delete) || '已删除' }}
                  </template>

                  <template v-else-if="record.competitionStatus=='0'">
                    {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.has_cancel) || '已取消' }}
                  </template>

                  <template v-else>
                    <template v-if="record.competitionSignup=='03'">
                      <template v-if="currentTime < record.localEndtimeStr">
                        {{ record.competitionSignup_dictText }}
                      </template>

                      <!-- 截止报名 -->
                      <template v-if="currentTime >= record.localEndtimeStr">
                        {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.competition_signup_end) || '报名截止' }}
                      </template>
                    </template>

                    <template v-else>
                      {{ record.competitionSignup_dictText }}
                    </template>
                  </template>
                </template>

                <span slot="checkStatus" slot-scope="text, record">
                  <!-- <a-tooltip placement="topRight">
                    <template slot="title" v-if="record.checkStatus!='03' && record.checkRemark!=null && record.checkRemark!==''">
                      <span v-html="record.checkRemark.replaceAll('\n','<br />')"></span>
                    </template>
                    <span v-html="text" class="mr6"></span><a-icon type="info-circle" style="color: rgba(0,0,0,.45)" v-if="record.checkStatus!='03' && record.checkRemark!=null && record.checkRemark!==''" />
                  </a-tooltip> -->
                  <a-tooltip placement="topRight">
                    <!-- 如果是 '03'，显示"报名成功" -->
                    <span v-if="record.checkStatus === '03'">
                      {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.registrantion_successful) || '报名成功' }}
                    </span>

                    <!-- 否则正常显示 text，并带 tooltip 提示 checkRemark -->
                    <template v-else>
                      <template slot="title" v-if="record.checkStatus != '03' && record.checkRemark != null && record.checkRemark !== ''">
                        <span v-html="record.checkRemark.replaceAll('\n','<br />')"></span>
                      </template>
                      <span v-html="text" class="mr6"></span>
                      <a-icon
                        type="info-circle"
                        style="color: rgba(0,0,0,.45)"
                        v-if="record.checkStatus != '03' && record.checkRemark != null && record.checkRemark !== ''"
                      />
                    </template>
                  </a-tooltip>
                </span>
                <span slot="awardNames" slot-scope="text, record" @click="queryCertificatesList(record.id)" class="compEditBtn mr8" v-if="Number(record.awardRecord) === 1">
                  {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.select) || '查看' }}
                </span>
                <span slot="teenagerInfo" slot-scope="text, record" @click="queryTeenagerInfo(record)" class="compEditBtn mr8" v-if="isTeenagerTemplate(record)">
                  {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.select) || '查看' }}
                </span>

                <template slot="action" slot-scope="text, record">
                  <div class="antTableAction">
                    <div v-if="record.checkStatus === '3'">
                      <span @click="clickInfo(record, 'see')" class="compEditBtn mr8">{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.select) || '查看' }}</span>
                    </div>
                    <div v-else>
                      <a-dropdown>
                        <a class="ant-dropdown-link" @click.prevent>
                          {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.more) || '更多' }}
                          <a-icon type="down" />
                        </a>
                        <template #overlay>
                          <a-menu>
                            <template>
                              <a-menu-item
                                @click="clickInfo(record, 'edit')" v-if="(record.isCaptain === 1
                                  || (record.isCaptain === 0 && record.checkStatus !== '09' && record.checkStatus !== '08'))
                                  && currentTime <= record.localEndtimeStr"
                              >
                                <a href="javascript:;">{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.team_information) || '团队信息' }}</a>
                              </a-menu-item>
                              <a-menu-item @click="clickInfo(record, 'see')" v-if="currentTime >= record.localEndtimeStr">
                                <a href="javascript:;">{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.team_information) || '团队信息' }}</a>
                              </a-menu-item>
                              <a-menu-item v-if="currentTime <= record.localEndtimeStr" @click="editPerson(record)" v-show="getMemberIstegg(record)">
                                <a href="javascript:;">{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.edit) || '编辑' }}</a>
                              </a-menu-item>
                              <a-menu-item @click="improveInfo(record)" v-if="record.certificatesContext">
                                <a href="javascript:;">{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.improve_information) || '完善认证信息' }}</a>
                              </a-menu-item>
                              <a-menu-item
                                v-for="certificateAction in getCertificateActions(record)"
                                :key="`${record.id}-${certificateAction.type}`"
                                @click="multiLanguageInfo(record, certificateAction.type)"
                              >
                                <a href="javascript:;">{{ certificateAction.label }}</a>
                              </a-menu-item>
                              <a-menu-item @click="unSubmit(record)" v-if="currentTime <= record.localEndtimeStr">
                                <a href="javascript:;">{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.unregister) || '取消报名' }}</a>
                              </a-menu-item>
                              <!-- <a-menu-item @click="seeInfo(record)">
                                 <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.person_team_member }}</a>
                               </a-menu-item> -->
                              <a-menu-item @click="openRepoManager(record)" v-if="record.checkStatus === '03'">
                                <a href="javascript:;">{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.repo_management) || '仓库管理' }}</a>
                              </a-menu-item>
                            </template>
                          </a-menu>
                        </template>
                      </a-dropdown>
                    </div>
                  </div>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <personedit :personedit.sync="personedit" :curid.sync="curid" @SignupRecordList="SignupRecordList" />
    <!--    修改报名信息弹框-->
    <!--    <formsign :formsign.sync="formsign" :cur-info-array.sync="curInfoArray" :person-list="personList" @itemclick="formsignFun"/>-->
    <formsign-new :formsign.sync="formsign" :cur-info-array.sync="curInfoArray" :person-list="personList" @itemclick="formsignFun" :title-name="(globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.team_information) || '团队信息'" :sub-button="(globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.submit) || '提交'" :read-only="personReadly" @SignupRecordList="SignupRecordList" />

    <improve-info ref="improveInfo" :info-pop.sync="infoPop" :info-data="personInfo" :is-teenager-mode="isTeenagerMode" :current-member="currentTeenagerMember" @close="handleImproveInfoClose" />
    <multi-language-info :visible.sync="multiLanguageVisible" :record-data="multiLanguageRecord" :is-teenager-mode="isTeenagerMode" :current-member="currentTeenagerMember" @close="handleMultiLanguageInfoClose" />
    <formmsg-edit-new :formsign.sync="formmsg" :cur-info-array.sync="personEditInfo" :team-array="personEditInfo" :person-list="personEdit" :sub-button="(globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.submit) || '提交'" :title-name="(globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.modify_personaal) || '修改个人信息'" @SignupRecordList="SignupRecordList" />
    <PersonCheck :infoPop.sync="personPop" :check-list="checkList" :person="person" @init="init" />
    <privacy-statement :privacy-statement.sync="privacyStatement" :cur-info-array.sync="privacyStatementRecord" :is-loading="isImprovingInfo" @itemclick="privacyStatementFun" />

    <!-- 青少年信息查看组件 -->
    <TeenagerInfoCheck
      :info-pop.sync="teenagerInfoPop"
      :check-list="teamMembersList"
      :team-record="currentTeamRecord"
      :operation-type="currentOperationType"
      @member-selected="handleMemberSelected"
    />

    <a-modal
      :visible="repoManagerVisible"
      :title="currentRepoRecord.competitionTitle ? `${currentRepoRecord.competitionTitle} - 仓库管理` : '仓库管理'"
      :footer="null"
      :mask-closable="!repoSubmitting"
      :closable="!repoSubmitting"
      width="720px"
      destroy-on-close
      @cancel="closeRepoManager"
    >
      <div class="repo-manager-section">
        <h3>{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.repo_can_create) || '可创建仓库' }}</h3>
        <a-spin :spinning="repoLoading">
          <div v-if="competitionRepoList.length" class="repo-create-row">
            <a-select
              v-model="selectedCompetitionRepoId"
              class="repo-select"
              :disabled="repoSubmitting"
              :placeholder="(globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.repo_select_placeholder) || '请选择报名仓库'"
            >
              <a-select-option
                v-for="repo in competitionRepoList"
                :key="repo.id"
                :value="repo.id"
                :disabled="repo.isSignuped"
              >
                {{ repo.repoUrl }}{{ repo.isSignuped ? ((globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.repo_already_created_suffix) || '（已创建）') : '' }}
              </a-select-option>
            </a-select>
            <a-button
              type="primary"
              :loading="repoSubmitting"
              :disabled="!selectedCompetitionRepoId"
              @click="createCompetitionRepo"
            >
              {{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.create_repository) || '创建仓库' }}
            </a-button>
          </div>
          <a-empty v-else :description="(globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.repo_not_configured) || '赛事暂未配置仓库'" />
        </a-spin>
      </div>

      <div class="repo-manager-section created-repo-section">
        <h3>{{ (globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.repo_created_list) || '已创建仓库列表' }}</h3>
        <a-spin :spinning="signupRepoLoading">
          <div v-if="signupRepoList.length" class="created-repo-list">
            <div v-for="repo in signupRepoList" :key="repo.id || repo.repoUrl" class="created-repo-item">
              <a :href="repo.repoUrl" target="_blank" rel="noopener noreferrer">{{ repo.repoUrl }}</a>
            </div>
          </div>
          <a-empty v-else :description="(globalDataArray.siteTemplateLanguage && globalDataArray.siteTemplateLanguage.repo_no_created) || '暂无已创建仓库'" />
        </a-spin>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { stringToDateTime } from '@/utils/util'
import {
  cancelRecord,
  selectOneTeamRecord,
  SignupRecordList,
  teamRecord,
  getUserInfoBySignupId,
  getMemberBySourceId,
  cancelLog
} from '@/api/person/person'
import { forkRepository, getCompetitionInfo, getCompetitionRepos, getCompetitionSignupRepos } from '@/api/saiti'
import { message } from 'ant-design-vue'
import Cookies from 'js-cookie'
import { getAdList, getCertificates } from '@/api/api'
import Formsign from '@/components/global/formsign/index.vue'
import ImproveInfo from '@/views/person/component/ImproveInfo.vue'
import MultiLanguageInfo from '@/views/person/component/MultiLanguageInfo.vue'
import FormsignNew from '@/components/global/formsign/FormsignNew.vue'
import dayjs from 'dayjs'
import FormmsgEditNew from '@/components/global/formmsg/FormmsgNew.vue'
import PersonCheck from '@/views/person/component/PersonCheck.vue'
import TeenagerInfoCheck from '@/views/person/component/TeenagerInfoCheck.vue'
import PrivacyStatement from '@/components/global/privacyStatement/index.vue'

export default {
  name: 'Myrecord',
  components: { FormmsgEditNew, FormsignNew, ImproveInfo, MultiLanguageInfo, Formsign, PersonCheck, TeenagerInfoCheck, PrivacyStatement },
  data() {
    return {
      title: (this.globalDataArray && this.globalDataArray.siteInfo && this.globalDataArray.siteInfo.title) || '',
      description: (this.globalDataArray && this.globalDataArray.siteInfo && this.globalDataArray.siteInfo.description) || '',
      keywords: (this.globalDataArray && this.globalDataArray.siteInfo && this.globalDataArray.siteInfo.keywords) || '',
      saitiAccessInfo: {},
      paginationOpt: {
        current: 1,
        total: 0,
        defaultCurrent: 1,
        defaultPageSize: 10,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (current, size) => {
          this.defaultPageSize = size
          this.paginationOpt.current = current
          this.SignupRecordList()
        },
        // onChange:在分页数量和当前页发生变化时触发
        onShowSizeChange: (current, pageSize) => {
          this.paginationOpt.pageSize = pageSize
        }
      },
      currentTime: 0, // 初始化为0，在mounted时设置
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => {
            return ((this.paginationOpt.current - 1) * this.paginationOpt.pageSize + index + 1)
          }
        },
        {
          title: '赛事名称',
          align: 'center',
          width: 180,
          dataIndex: 'competitionTitle',
          scopedSlots: { customRender: 'tit' },
          ellipsis: true,
          sorter: (a, b) => a.competitionTitle.length - b.competitionTitle.length
        },
        {
          title: '获奖信息',
          align: 'center',
          dataIndex: 'awardNames',
          scopedSlots: { customRender: 'awardNames' },
          sorter: (a, b) => a.awardNames.length - b.awardNames.length
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'checkStatus_dictText',
          scopedSlots: { customRender: 'checkStatus' },
          sorter: (a, b) => a.checkStatus_dictText.length - b.checkStatus_dictText.length
        },
        {
          title: '比赛状态',
          align: 'center',
          dataIndex: 'competitionSignup_dictText',
          scopedSlots: { customRender: 'curstatus' },
          sorter: (a, b) => a.competitionSignup_dictText.length - b.competitionSignup_dictText.length
        },
        /*        {
          title: '赛道名称',
          width: 140,
          align: 'center',
          dataIndex: 'categoryTitle',
          sorter: (a, b) => a.categoryTitle.length - b.categoryTitle.length
        },*/
        {
          title: '报名截止时间',
          align: 'center',
          dataIndex: 'competitionEndTime',
          sorter: (a, b) => dayjs(a.competitionEndTime, 'DD-MM-YYYY HH:mm:ss').unix() - dayjs(b.competitionEndTime, 'DD-MM-YYYY HH:mm:ss').unix()
        },
        {
          title: '报名时间',
          width: 170,
          align: 'left',
          dataIndex: 'createTime',
          sorter: (a, b) => dayjs(a.createTime, 'DD-MM-YYYY HH:mm:ss').unix() - dayjs(b.createTime, 'DD-MM-YYYY HH:mm:ss').unix()
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      checkList: Object.freeze([]), // 使用 Object.freeze 防止Vue响应式包装，避免SSR不匹配
      list: [],

      personedit: false,
      curid: {},
      banners: {},
      formsign: false, // 修改弹窗
      curInfoArray: {},
      personList: {
        temp: []
      },
      infoPop: false,
      formmsg: false, // 信息弹窗
      personEditInfo: {},
      personEdit: {}, // 编辑弹窗
      personReadly: false,
      personInfo: {},
      multiLanguageVisible: false, // 多语言信息弹窗
      multiLanguageRecord: {}, // 多语言信息记录
      personPop: false,
      person: {},
      privacyStatement: false, // 隐私声明确认弹窗
      privacyStatementRecord: {}, // 隐私声明记录
      // 新增：青少年模式相关变量
      currentTeenagerMember: {}, // 当前选中的青少年团队成员
      isTeenagerMode: false, // 当前是否处于青少年模式

      // 新增：青少年信息查看组件相关变量
      teenagerInfoPop: false, // 青少年信息查看弹窗显示状态
      teamMembersList: [], // 团队成员列表
      currentTeamRecord: {}, // 当前团队记录
      currentOperationType: 'improve', // 当前操作类型：'improve' 完善认证信息, 'multiLanguage' 完善证书信息

      // 新增：加载状态相关变量
      isImprovingInfo: false, // 是否正在完善信息（加载状态）

      // 仓库管理
      repoManagerVisible: false,
      currentRepoRecord: {},
      competitionRepoList: [],
      signupRepoList: [],
      selectedCompetitionRepoId: undefined,
      repoLoading: false,
      signupRepoLoading: false,
      repoSubmitting: false

    }
  },
  watch: {
    personPop(val) {
      if (!val) {
        // 确保弹窗关闭时重置数据为一致状态，避免SSR不匹配
        this.checkList = Object.freeze([])
      }
    },
    // 新增：监听完善信息弹窗状态
    infoPop(val) {
      if (!val) {
        // 弹窗关闭时重置青少年模式状态
        this.isTeenagerMode = false
        this.currentTeenagerMember = {}
      }
    },
    // 新增：监听多语言信息弹窗状态
    multiLanguageVisible(val) {
      if (!val) {
        // 弹窗关闭时重置青少年模式状态
        this.isTeenagerMode = false
        this.currentTeenagerMember = {}
      }
    }
  },
  mounted() {
    this.currentTime = new Date().getTime() // 在客户端设置当前时间
    this.init()
  },
  methods: {
    init() {
      console.log('init')
      this.getAdList()
      this.tableHeader()
      this.SignupRecordList()
      try {
        const saitiAccessInfoCookie = Cookies.get('saiti_access_info')
        if (saitiAccessInfoCookie && saitiAccessInfoCookie !== '' && saitiAccessInfoCookie !== 'undefined' && saitiAccessInfoCookie !== 'null') {
          this.saitiAccessInfo = JSON.parse(saitiAccessInfoCookie)
        }
      } catch (error) {
        console.warn('解析saiti_access_info失败:', error)
        this.saitiAccessInfo = {}
      }
      // this.seeInfo();
    },
    tableHeader() {
      const that = this
      if (that.globalDataArray && that.globalDataArray.siteTemplateLanguage) {
        that.columns[0].title = that.globalDataArray.siteTemplateLanguage.person_table_number || '序号'
        that.columns[1].title = that.globalDataArray.siteTemplateLanguage.person_table_competition_title || '赛事名称'
        // that.columns[2].title = that.globalDataArray.siteTemplateLanguage.competition_bonus
        // that.columns[4].title = that.globalDataArray.siteTemplateLanguage.person_table_competition_category
        that.columns[5].title = that.globalDataArray.siteTemplateLanguage.person_table_signup_endtime || '报名截止时间'
        that.columns[4].title = that.globalDataArray.siteTemplateLanguage.person_table_status || '比赛状态'
        that.columns[6].title = that.globalDataArray.siteTemplateLanguage.person_table_signup_create_time || '报名时间'
        that.columns[3].title = that.globalDataArray.siteTemplateLanguage.person_table_signup_check_status || '审核状态'
        that.columns[2].title = that.globalDataArray.siteTemplateLanguage.award_information || '获奖信息'
        that.columns[7].title = that.globalDataArray.siteTemplateLanguage.person_table_controls || '操作'
      }
      // console.log(this.columns,'columns')
    },
    SignupRecordList() {
      const that = this
      const param = 'page=' + that.paginationOpt.current + '&pageSize=' + that.paginationOpt.defaultPageSize
      SignupRecordList(param).then(res => {
        if (res.success) {
          that.list = res.result.records || []
          that.paginationOpt.total = res.result.total || 0

          that.list.forEach((item, index) => {
            if (item && item.endUtcTime) {
              try {
                const endUtcTime = item.endUtcTime
                const localEndtimeStr = new Date(endUtcTime).getTime()
                item['localEndtimeStr'] = localEndtimeStr
              } catch (error) {
                console.warn('处理时间失败:', error)
                item['localEndtimeStr'] = 0
              }
            } else {
              item['localEndtimeStr'] = 0
            }
          })
        } else {
          that.list = []
          that.paginationOpt.total = 0
        }
      }).catch(error => {
        console.error('获取报名记录失败:', error)
        that.list = []
        that.paginationOpt.total = 0
      })
    },
    getAdList() {
      const that = this
      const adParam = 'alias=person_banner'
      getAdList(adParam).then(res => {
        if (res.success && res.result && res.result.length > 0) {
          that.banners = res.result[0] || {}
        } else {
          that.banners = {}
        }
      }).catch(error => {
        console.error('获取广告列表失败:', error)
        that.banners = {}
      })
    },
    async queryCertificatesList(id) {
      this.personPop = true
      try {
        const res = await getCertificates(id)
        if (res.success && res.result && res.result.records) {
          // 确保数据是普通数组，避免响应式对象引用问题
          const records = res.result.records
          if (Array.isArray(records)) {
            // 深度克隆数据并冻结，防止Vue响应式包装
            const clonedRecords = records.map(item => Object.assign({}, item))
            this.checkList = Object.freeze(clonedRecords)
          } else {
            this.checkList = Object.freeze([])
          }
        } else {
          this.checkList = Object.freeze([])
          this.$message.error(res.message || '获取失败')
        }
      } catch (error) {
        console.error('获取证书列表失败:', error)
        this.checkList = Object.freeze([])
        this.$message.error('请求异常')
      } finally {
        this.loading = false
      }
    },
    async queryTeenagerInfo(record) {
      try {
        console.log('开始查询青少年信息，record:', record)

        // 获取团队所有成员信息
        const teamMembers = await this.getTeamMembers(record)
        console.log('获取到的团队成员:', teamMembers)

        if (teamMembers.length === 0) {
          this.$message.error('未找到团队成员信息')
          return
        }

        // 设置数据并显示弹窗
        this.teamMembersList = teamMembers
        this.currentTeamRecord = record
        this.teenagerInfoPop = true
      } catch (error) {
        console.error('获取青少年信息失败:', error)
        this.$message.error('获取青少年信息失败')
      }
    },

    // 处理成员选择事件（isTeenagerMode 已在打开弹窗时由 handleTeenagerMultiLanguageInfo / handleAdultMultiLanguageInfo 等设置，此处不再覆盖）
    handleMemberSelected(data) {
      const { member, teamRecord, operationType } = data
      console.log('选中的成员:', member)
      console.log('团队记录:', teamRecord)
      console.log('操作类型:', operationType)

      this.currentTeenagerMember = member

      // 构造"伪装"数据
      const disguisedRecord = {
        ...teamRecord,
        id: member.id, // 使用队员的signupId
        signupId: member.id, // 使用队员的signupId
        isCaptain: member.isCaptain, // 队员的队长标识
        personName: member.userName || member.personName,
        userName: member.userName || member.personName,
        userPhone: member.userPhone || member.phoneNumber,
        phoneNumber: member.userPhone || member.phoneNumber,
        // 保持团队信息不变
        teamName: teamRecord.teamName,
        grade: teamRecord.grade,
        groupId: teamRecord.groupId
      }

      // 根据操作类型分别处理
      if (operationType === 'improve') {
        // 完善认证信息：需要隐私协议
        this.privacyStatementRecord = disguisedRecord
        this.privacyStatement = true
      } else if (operationType === 'multiLanguage') {
        // 完善证书信息：不需要隐私协议，直接调用
        this.selectMemberForMultiLanguage(member, teamRecord)
      }
    },
    seeInfo(record) {
      // console.log(id)
      const that = this
      that.personedit = true
      that.curid = record
    },
    // 编辑
    async editPerson(record) {
      // this.personEditInfo = record
      this.personEditInfo = JSON.parse(record.sigupJson)
      this.personEditInfo.competitionId = record.competitionParentId
      console.log(this.personEditInfo, 'editPerson')
      const params = 'id=' + record.id
      const res = await selectOneTeamRecord(params)
      if (res.success) {
        const jsonTeam = JSON.parse(res.result.sigup_json)
        jsonTeam.id = res.result.id
        jsonTeam.countryCode = { key: jsonTeam.countryCode, label: jsonTeam.countryName }
        jsonTeam.cityCode = { key: jsonTeam.cityCode, label: jsonTeam.cityName }
        this.personEditInfo.parentId = res.result.parent_id
        this.personEdit = jsonTeam
        this.formmsg = true
        console.log('selectOneTeamRecord result sigup_json:', res.result.sigup_json)
        console.log('jsonTeam.userPhone:', jsonTeam.userPhone, 'jsonTeam.userMail:', jsonTeam.userMail)
        console.log(res.result, 'editPerson')
      }
    },

    getMemberIstegg(record) {
      const json = JSON.parse(record.sigupJson)
      if (json.userNameNew) {
        return false
      } else {
        return true
      }
    },

    delCancel(record) {
      const that = this
      if (record.competitionDelflag == '1') {
        // 已删除
        message.error((that.globalDataArray && that.globalDataArray.siteTemplateLanguage && that.globalDataArray.siteTemplateLanguage.has_delete) || '已删除')
      } else if (record.competitionStatus == '0') {
        // 已下架
        message.error((that.globalDataArray && that.globalDataArray.siteTemplateLanguage && that.globalDataArray.siteTemplateLanguage.has_cancel) || '已取消')
      }
    },

    // 取消报名
    unSubmit(record) {
      this.$confirm({
        title: `${(this.globalDataArray && this.globalDataArray.siteTemplateLanguage && this.globalDataArray.siteTemplateLanguage.delete_record) || '删除记录'}`,
        content: `${(this.globalDataArray && this.globalDataArray.siteTemplateLanguage && this.globalDataArray.siteTemplateLanguage.with_caution) || '请谨慎操作'}`,
        okText: `${(this.globalDataArray && this.globalDataArray.siteTemplateLanguage && this.globalDataArray.siteTemplateLanguage.verify) || '确认'}`,
        okType: 'danger',
        cancelText: `${(this.globalDataArray && this.globalDataArray.siteTemplateLanguage && this.globalDataArray.siteTemplateLanguage.cancel) || '取消'}`,
        onOk: async () => {
          const param = 'id=' + record.id + '&isCaptain=' + record.isCaptain + '&teamNo=' + record.teamNo
          const res = await cancelRecord(param)
          if (res.success) {
            this.$message.success((this.globalDataArray && this.globalDataArray.siteTemplateLanguage && this.globalDataArray.siteTemplateLanguage.success_withdrawn) || '取消报名成功')
            this.SignupRecordList()
          }
        },
        onCancel: () => { // 使用箭头函数
          console.log('Cancel')
        }
      })
    },

    // 详情
    async clickInfo(record, type) {
      if (record.isCaptain === 0) {
        type = 'see'
      }
      if (type === 'see') {
        this.personReadly = true
      } else {
        this.personReadly = false
      }
      const jsonData = JSON.parse(record.sigupJson)
      // 获取最新的赛事配置，而不是使用报名时保存的旧值
      let latestTeamsUsers = jsonData.teamsUsers
      try {
        const competitionRes = await getCompetitionInfo('id=' + record.competitionParentId)
        if (competitionRes.success && competitionRes.result) {
          latestTeamsUsers = competitionRes.result.teamsUsers
        }
      } catch (e) {
        console.log('获取最新赛事配置失败，使用报名时的配置:', e)
      }
      record.teamsUsers = latestTeamsUsers
      record.competitionId = record.competitionParentId
      record.currentLanguge = jsonData.currentLanguge
      this.curInfoArray = record
      console.log(record, 'record')
      this.personList = {
        temp: []
      }
      if (record.checkStatus === '3') {
        const res = await cancelLog('signupId=' + record.id)
        if (res.success) {
          const teamList = res.result.records
          teamList.forEach(item => {
            const jsonTeam = JSON.parse(item.sigupJson)
            jsonTeam.id = item.id
            jsonTeam.countryCode = { key: jsonTeam.countryCode, label: jsonTeam.countryName }
            jsonTeam.cityCode = { key: jsonTeam.cityCode, label: jsonTeam.cityName }
            if (item.isCaptain === 1) {
              this.personList = jsonTeam
              jsonTeam.temp = []
            } else {
              this.personList.temp.push(jsonTeam)
            }
          })
          this.formsign = true
        }
        return
      }
      const params = 'competitionId=' + record.competitionId + '&parentId=' + record.parentId
      const resNew = await teamRecord(params)
      if (resNew.success) {
        const teamList = resNew.result.records
        teamList.forEach(item => {
          const jsonTeam = JSON.parse(item.sigupJson)
          jsonTeam.id = item.id
          jsonTeam.countryCode = { key: jsonTeam.countryCode, label: jsonTeam.countryName }
          jsonTeam.cityCode = { key: jsonTeam.cityCode, label: jsonTeam.cityName }
          if (item.isCaptain === 1) {
            this.personList = jsonTeam
            jsonTeam.temp = []
          } else {
            this.personList.temp.push(jsonTeam)
          }
        })
        this.formsign = true
      }
    },

    // 完善信息
    async improveInfo(record) {
      console.log(record)

      // 新增：青少年模板特殊处理
      if (this.isTeenagerTemplate(record)) {
        await this.handleTeenagerImproveInfo(record)
        return // 青少年模板直接返回，不执行原有逻辑
      }

      // 新增：成人比赛队长也使用队员选择方式
      if (record.isCaptain === 1) {
        await this.handleAdultImproveInfo(record)
        return
      }

      // 原有逻辑保持不变（队员直接编辑自己的）
      this.privacyStatementRecord = record
      this.privacyStatement = true
    },

    // 新增：判断是否为青少年模板
    isTeenagerTemplate(record) {
      try {
        const jsonData = JSON.parse(record.sigupJson)
        // 青少年模板特征：存在 grade 字段
        return jsonData.grade
      } catch (e) {
        return false
      }
    },

    parseSignupJson(record) {
      if (!record || !record.sigupJson) {
        return {}
      }
      try {
        return JSON.parse(record.sigupJson)
      } catch (e) {
        return {}
      }
    },

    getCertificateActions(record) {
      if (!record || !record.certificatesContext || record.isCaptain !== 1) {
        return []
      }

      const actions = []
      if (this.shouldShowContestantCertificate(record)) {
        actions.push({ type: 'C', label: '完善证书信息' })
      }
      // 完善教师证书信息：任何条件下均不展示
      if (this.shouldShowParticipatingUnitCertificate(record)) {
        actions.push({ type: 'PU', label: '完善参赛单位证书信息' })
      }
      return actions
    },

    shouldShowContestantCertificate(record) {
      return !!(record && record.certificatesContext && record.isCaptain === 1)
    },

    shouldShowTeacherCertificate() {
      // 产品要求：完善教师证书信息入口任何条件下均隐藏
      return false
    },

    shouldShowParticipatingUnitCertificate(record) {
      const signupJson = this.parseSignupJson(record)
      const company = signupJson.companyName ||
        signupJson.companyFullName ||
        signupJson.company_full_name
      return !!(record && record.certificatesContext && record.isCaptain === 1 && company)
    },

    // 新增：青少年完善信息处理
    async handleTeenagerImproveInfo(record) {
      try {
        this.isTeenagerMode = true
        console.log('开始处理青少年完善信息，record:', record)

        // 1. 获取团队所有成员信息
        // 传入完整的record对象以获取competitionId和parentId
        const teamMembers = await this.getTeamMembers(record)
        console.log('获取到的团队成员:', teamMembers)

        if (teamMembers.length === 0) {
          console.warn('团队成员数组为空')
          this.$message.error('未找到团队成员信息')
          return
        }

        // 2. 显示成员选择器
        this.currentOperationType = 'improve'
        this.teamMembersList = teamMembers
        this.currentTeamRecord = record
        this.teenagerInfoPop = true
      } catch (error) {
        console.error('获取团队成员信息失败:', error)
        console.error('错误堆栈:', error.stack)
        this.$message.error('获取团队成员信息失败')
      }
    },

    // 新增：成人比赛完善信息处理
    async handleAdultImproveInfo(record) {
      try {
        this.isTeenagerMode = false
        console.log('开始处理成人比赛完善信息，record:', record)

        // 1. 获取团队所有成员信息
        const teamMembers = await this.getTeamMembers(record)
        console.log('获取到的成人比赛团队成员:', teamMembers)

        if (teamMembers.length === 0) {
          console.warn('成人比赛团队成员数组为空')
          this.$message.error('未找到团队成员信息')
          return
        }

        // 2. 显示成员选择器
        this.currentOperationType = 'improve'
        this.teamMembersList = teamMembers
        this.currentTeamRecord = record
        this.teenagerInfoPop = true
      } catch (error) {
        console.error('获取成人比赛团队成员信息失败:', error)
        console.error('错误堆栈:', error.stack)
        this.$message.error('获取团队成员信息失败')
      }
    },

    // 新增：获取团队成员
    async getTeamMembers(record) {
      try {
        // 通过队长的记录获取团队信息
        // 使用teamRecord接口获取团队所有成员信息
        // 需要传入正确的competitionId和parentId
        // 从你提供的数据看，应该使用competitionParentId作为competitionId
        const competitionId = record.competitionParentId || record.competitionId
        const parentId = record.parentId || record.id

        const params = 'competitionId=' + competitionId + '&parentId=' + parentId
        console.log('获取团队成员参数:', params)
        console.log('原始record数据:', record)

        const res = await teamRecord(params)
        console.log('teamRecord接口返回:', res)
        console.log('res.success:', res.success)
        console.log('res.result:', res.result)
        console.log('res.result.records:', res.result?.records)
        console.log('Array.isArray(res.result.records):', Array.isArray(res.result?.records))

        if (res.success && res.result && res.result.records && Array.isArray(res.result.records)) {
          // 将返回的记录转换为团队成员格式
          const teamMembers = res.result.records.map(teamRecord => {
            try {
              const jsonData = JSON.parse(teamRecord.sigupJson)
              return {
                id: teamRecord.id,
                userName: jsonData.userName || jsonData.userNameNew || '',
                personName: jsonData.userName || jsonData.userNameNew || '',
                userPhone: teamRecord.userPhone || jsonData.userPhone || '',
                phoneNumber: teamRecord.userPhone || jsonData.userPhone || '',
                isCaptain: teamRecord.isCaptain,
                teamName: jsonData.teamName,
                grade: jsonData.grade,
                groupId: jsonData.groupId,
                cityName: jsonData.cityName,
                countryName: jsonData.countryName,
                company: jsonData.company,
                userMail: teamRecord.userMail || jsonData.userMail || ''
              }
            } catch (e) {
              console.error('解析团队成员数据失败:', e)
              return {
                id: teamRecord.id,
                userName: teamRecord.userName || '',
                personName: teamRecord.userName || '',
                userPhone: teamRecord.userPhone || '',
                phoneNumber: teamRecord.userPhone || '',
                isCaptain: teamRecord.isCaptain,
                teamName: teamRecord.teamName,
                grade: null,
                groupId: null,
                cityName: teamRecord.cityName,
                countryName: teamRecord.countryName,
                company: teamRecord.company,
                userMail: teamRecord.userMail || ''
              }
            }
          })

          console.log('转换后的团队成员:', teamMembers)
          return teamMembers
        } else {
          console.warn('teamRecord接口返回数据格式不正确:', res)
          console.warn('res.success:', res.success)
          console.warn('res.result:', res.result)
          console.warn('res.result.records:', res.result?.records)
          console.warn('Array.isArray(res.result.records):', Array.isArray(res.result?.records))
          return []
        }
      } catch (error) {
        console.error('获取团队成员信息失败:', error)
        return []
      }
    },

    // 新增：选择成员后处理
    async selectMemberForImprove(member, teamRecord) {
      // 关闭团队成员选择器弹窗
      this.closeTeamMemberSelector()

      // 设置青少年模式状态
      this.isTeenagerMode = true
      this.currentTeenagerMember = member

      // 构造"伪装"数据
      const disguisedRecord = {
        ...teamRecord,
        id: member.id, // 使用队员的signupId
        signupId: member.id, // 使用队员的signupId
        isCaptain: member.isCaptain, // 队员的队长标识
        personName: member.userName || member.personName,
        userName: member.userName || member.personName,
        userPhone: member.userPhone || member.phoneNumber,
        phoneNumber: member.userPhone || member.phoneNumber,
        // 保持团队信息不变
        teamName: teamRecord.teamName,
        grade: teamRecord.grade,
        groupId: teamRecord.groupId
      }

      // 调用原有的完善信息逻辑，但传入"伪装"的数据
      this.privacyStatementRecord = disguisedRecord
      this.privacyStatement = true
    },

    // 新增：关闭团队成员选择器弹窗
    closeTeamMemberSelector() {
      this.teenagerInfoPop = false
      this.teamMembersList = []
      this.currentTeamRecord = {}
    },

    // 隐私声明确认回调
    privacyStatementFun(res) {
      if (res === '1') {
        // 用户同意隐私声明，继续显示完善信息
        this.showImproveInfo()
      }
    },

    // 显示完善信息
    async showImproveInfo() {
      try {
        // 设置加载状态
        this.isImprovingInfo = true

        const record = this.privacyStatementRecord
        const params = 'id=' + record.id
        const res = await selectOneTeamRecord(params)
        const member = await getMemberBySourceId()
        const userParams = 'signupId=' + record.id
        const userInfo = await getUserInfoBySignupId(userParams)
        console.log(userInfo, 'userInfo')

        if (res.success) {
          const jsonTeam = JSON.parse(res.result.sigup_json)
          if (member && member.result && member.result.deliveryAddress) {
            jsonTeam.deliveryAddress = member.result.deliveryAddress
          }
          if (userInfo && userInfo.result) {
            jsonTeam.idCard = userInfo.result.idCard
            jsonTeam.bankCardNumber = userInfo.result.bankCardNumber
            jsonTeam.personNumber = userInfo.result.personNumber
            jsonTeam.personName = userInfo.result.personName
            jsonTeam.bankName = userInfo.result.bankName
            jsonTeam.accountName = userInfo.result.accountName
            jsonTeam.receiverPhone = userInfo.result.receiverPhone
            jsonTeam.receiverIdCard = userInfo.result.receiverIdCard
            jsonTeam.attachment = userInfo.result.attachment
            jsonTeam.id = userInfo.result.id
            if (typeof userInfo.result.deliveryAddress === 'string' &&
                userInfo.result.deliveryAddress.trim() !== '') {
              jsonTeam.deliveryAddress = userInfo.result.deliveryAddress
            }
          }
          jsonTeam.signupId = record.id
          // 添加sysOrgcode字段
          jsonTeam.sysOrgCode = record.sysOrgCode || res.result.sysOrgCode
          this.personInfo = jsonTeam

          // 数据加载完成，关闭隐私协议窗口，打开完善信息弹框
          this.privacyStatement = false
          this.infoPop = true
          this.$refs.improveInfo.init(jsonTeam)
        } else {
          this.$message.error('获取记录信息失败')
        }
      } catch (error) {
        console.error('完善信息过程中发生错误:', error)
        this.$message.error('获取数据时发生错误，请稍后重试')
      } finally {
        // 重置加载状态
        this.isImprovingInfo = false
      }
    },

    getRepoResultList(res) {
      const result = res && res.result
      if (Array.isArray(result)) return result
      if (Array.isArray(result?.records)) return result.records
      if (Array.isArray(result?.list)) return result.list
      if (Array.isArray(result?.data)) return result.data
      return []
    },
    async openRepoManager(record) {
      this.currentRepoRecord = record
      this.competitionRepoList = []
      this.signupRepoList = []
      this.selectedCompetitionRepoId = undefined
      this.repoManagerVisible = true

      await Promise.all([
        this.loadRecordCompetitionRepos(),
        this.loadRecordSignupRepos()
      ])
    },
    closeRepoManager() {
      if (this.repoSubmitting) return
      this.repoManagerVisible = false
      this.selectedCompetitionRepoId = undefined
      this.currentRepoRecord = {}
    },
    async loadRecordCompetitionRepos() {
      const competitionId = this.currentRepoRecord.competitionParentId
      if (!competitionId) {
        this.competitionRepoList = []
        return
      }

      this.repoLoading = true
      try {
        const res = await getCompetitionRepos(`competitionId=${competitionId}`)
        this.competitionRepoList = res.success ? this.getRepoResultList(res) : []

        const availableRepos = this.competitionRepoList.filter(repo => !repo.isSignuped)
        if (availableRepos.length === 1) {
          this.selectedCompetitionRepoId = availableRepos[0].id
        }
      } catch (error) {
        this.competitionRepoList = []
      } finally {
        this.repoLoading = false
      }
    },
    async loadRecordSignupRepos() {
      const parentId = this.currentRepoRecord.parentId
      if (!parentId) {
        this.signupRepoList = []
        return
      }

      this.signupRepoLoading = true
      try {
        const res = await getCompetitionSignupRepos(`parentId=${parentId}&page=1&pageSize=100`)
        this.signupRepoList = res.success ? this.getRepoResultList(res) : []
      } catch (error) {
        this.signupRepoList = []
      } finally {
        this.signupRepoLoading = false
      }
    },
    async createCompetitionRepo() {
      const record = this.currentRepoRecord
      if (!record.id || !this.selectedCompetitionRepoId) return

      const selectedRepo = this.competitionRepoList.find(repo => repo.id === this.selectedCompetitionRepoId)
      if (selectedRepo?.isSignuped) {
        this.$message.error('当前仓库已创建，不能重复创建')
        this.selectedCompetitionRepoId = undefined
        return
      }

      const token = localStorage.getItem('atomgit_oauth_access_token') || ''
      if (!token) {
        this.$router.push({
          path: '/login',
          query: { from: this.$route.fullPath }
        })
        return
      }

      this.repoSubmitting = true
      try {
        const res = await forkRepository({
          oauthToken: token,
          id: record.id,
          competitionRepoId: this.selectedCompetitionRepoId
        })

        if (res.success) {
          this.selectedCompetitionRepoId = undefined
          await Promise.all([
            this.loadRecordCompetitionRepos(),
            this.loadRecordSignupRepos()
          ])
          this.$message.success('仓库创建成功')
        } else if (res.code == 510) {
          this.$router.push({
            path: '/login',
            query: { from: this.$route.fullPath }
          })
        } else {
          this.$message.error((this.globalDataArray && this.globalDataArray.siteTemplateLanguage && this.globalDataArray.siteTemplateLanguage.create_repository_failed) || '创建仓库失败，请联系承办方')
        }
      } catch (error) {
        this.$message.error((this.globalDataArray && this.globalDataArray.siteTemplateLanguage && this.globalDataArray.siteTemplateLanguage.create_repository_failed) || '创建仓库失败，请联系承办方')
      } finally {
        this.repoSubmitting = false
      }
    },

    // 多语言信息
    async multiLanguageInfo(record, certificateType = 'C') {
      console.log(record)
      const recordWithCertificateType = {
        ...record,
        certificateType
      }

      // 新增：青少年模板特殊处理
      if (this.isTeenagerTemplate(recordWithCertificateType)) {
        await this.handleTeenagerMultiLanguageInfo(recordWithCertificateType, certificateType)
        return // 青少年模板直接返回，不执行原有逻辑
      }

      // 新增：成人比赛也使用队员选择方式
      if (recordWithCertificateType.isCaptain === 1) {
        await this.handleAdultMultiLanguageInfo(recordWithCertificateType, certificateType)
        return
      }

      // 原有逻辑保持不变（队员直接编辑自己的）
      const params = 'id=' + recordWithCertificateType.id
      const res = await selectOneTeamRecord(params)
      if (res.success) {
        this.multiLanguageRecord = {
          ...res.result,
          competitionId: recordWithCertificateType.competitionParentId || recordWithCertificateType.competitionId || res.result?.competition_id,
          certificateType: certificateType
        }
        this.multiLanguageVisible = true
        console.log('多语言信息数据:', this.multiLanguageRecord)
      } else {
        this.$message.error('获取记录信息失败')
      }
    },

    // 新增：青少年多语言信息处理
    async handleTeenagerMultiLanguageInfo(record, certificateType = 'C') {
      try {
        this.isTeenagerMode = true
        // 1. 获取团队所有成员信息
        const teamMembers = await this.getTeamMembers(record)

        // 2. 显示成员选择器
        this.currentOperationType = 'multiLanguage'
        this.teamMembersList = teamMembers
        this.currentTeamRecord = {
          ...record,
          certificateType
        }
        this.teenagerInfoPop = true
      } catch (error) {
        this.$message.error('获取团队成员信息失败')
      }
    },

    // 新增：成人比赛多语言信息处理
    async handleAdultMultiLanguageInfo(record, certificateType = 'C') {
      try {
        this.isTeenagerMode = false
        console.log('开始处理成人比赛多语言信息，record:', record)

        // 1. 获取团队所有成员信息
        const teamMembers = await this.getTeamMembers(record)
        console.log('获取到的成人比赛团队成员:', teamMembers)

        if (teamMembers.length === 0) {
          this.$message.error('未找到团队成员信息')
          return
        }

        // 2. 显示成员选择器
        this.currentOperationType = 'multiLanguage'
        this.teamMembersList = teamMembers
        this.currentTeamRecord = {
          ...record,
          certificateType
        }
        this.teenagerInfoPop = true
      } catch (error) {
        console.error('获取成人比赛团队成员信息失败:', error)
        this.$message.error('获取团队成员信息失败')
      }
    },

    // 新增：选择成员后处理多语言信息
    async selectMemberForMultiLanguage(member, teamRecord) {
      // 不关闭团队成员选择器弹窗，保持打开状态
      // this.closeTeamMemberSelector()

      // 注意：成人比赛不设置 isTeenagerMode = true
      // 只有青少年比赛才设置 isTeenagerMode = true
      // 成人比赛通过 currentMember 来判断是队长编辑队员
      this.currentTeenagerMember = member

      // 构造"伪装"数据
      const disguisedRecord = {
        ...teamRecord,
        id: member.id, // 使用队员的signupId
        signupId: member.id, // 使用队员的signupId
        isCaptain: member.isCaptain, // 队员的队长标识
        personName: member.userName || member.personName,
        userName: member.userName || member.personName,
        userPhone: member.userPhone || member.phoneNumber,
        phoneNumber: member.userPhone || member.phoneNumber,
        // 保持团队信息不变
        teamName: teamRecord.teamName,
        grade: teamRecord.grade,
        groupId: teamRecord.groupId,
        certificateType: teamRecord.certificateType
      }

      // 直接调用多语言信息逻辑，不需要隐私协议
      const params = 'id=' + disguisedRecord.id
      const res = await selectOneTeamRecord(params)
      if (res.success) {
        // 新增：获取队长的多语言字段值
        const captainFieldValues = await this.getCaptainFieldValues(teamRecord)

        // 新增：将队长的单位信息添加到 multiLanguageRecord 中
        this.multiLanguageRecord = {
          ...res.result,
          competitionId: teamRecord.competitionParentId || teamRecord.competitionId || res.result?.competition_id,
          certificateType: teamRecord.certificateType,
          // 从 teamRecord（队长记录）中获取单位信息
          company: teamRecord.company,
          companyName: teamRecord.companyName || teamRecord.company,
          companyFullName: teamRecord.companyFullName || teamRecord.company_full_name,
          company_full_name: teamRecord.company_full_name || teamRecord.companyFullName,
          // 新增：添加队长的多语言字段值
          captainFieldValues: captainFieldValues
        }
        this.multiLanguageVisible = true
        console.log('多语言信息数据（已添加队长单位信息和多语言字段值）:', this.multiLanguageRecord)
      } else {
        this.$message.error('获取记录信息失败')
      }
    },

    // 新增：获取队长的多语言字段值
    async getCaptainFieldValues(teamRecord) {
      try {
        const competitionId = teamRecord.competitionId ||
                             teamRecord.competition_id ||
                             teamRecord.parent_competition_id

        const params = {
          signupId: teamRecord.id,
          competitionId: competitionId,
          certificateType: teamRecord.certificateType || 'C'
        }

        const { getUserFieldConfigs } = await import('@/api/person/certificate')
        const res = await getUserFieldConfigs(params)

        if (res.success && res.result && res.result.fieldInfos) {
          // 返回字段配置，包含 languageValues
          return res.result.fieldInfos
        }
        return null
      } catch (error) {
        console.error('获取队长多语言字段值失败:', error)
        return null
      }
    },

    formsignFun(res) {
      console.log(res)
    },

    // 新增：处理完善信息表单关闭后的回调
    handleImproveInfoClose() {
      console.log('完善信息表单关闭，返回到成员选择弹框')

      // 关闭完善信息弹窗
      this.infoPop = false

      // 保持成员选择弹框打开状态，用户可以继续选择其他成员
      // 不需要重新显示成员选择器，因为它一直保持打开状态
    },

    // 新增：处理多语言信息表单关闭后的回调
    handleMultiLanguageInfoClose() {
      console.log('多语言信息表单关闭，返回到成员选择弹框')

      // 关闭多语言信息弹窗
      this.multiLanguageVisible = false

      // 保持成员选择弹框打开状态，用户可以继续选择其他成员
      // 不需要重新显示成员选择器，因为它一直保持打开状态
    }
  },
  metaInfo() {
    return {
      title: this.title || '报名记录',
      meta: [
        { vmid: 'description', name: 'description', content: this.description || '' },
        { vmid: 'keywords', name: 'keywords', content: this.keywords || '' }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/css/person.css';
::v-deep .ant-spin-container .ant-table-scroll .ant-table-body .ant-table-fixed .ant-table-tbody > tr > td {
  padding: 16px 6px ;
}
::v-deep .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
  background-color: #1281ff;
}
::v-deep .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on {
  color: #d7dee7;
}
::v-deep .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on {
  color: #d7dee7;
}

.title_first {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.repo-manager-section {
  h3 {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 600;
  }
}

.created-repo-section {
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
}

.repo-create-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.repo-select {
  flex: 1;
  min-width: 0;
}

.created-repo-item {
  padding: 8px 0;
  word-break: break-all;
}

.created-repo-item + .created-repo-item {
  border-top: 1px solid #f0f0f0;
}

@media (max-width: 768px) {
  .repo-create-row {
    align-items: stretch;
    flex-direction: column;
  }
}

/* 青少年模式成员选择器样式 */
.member-item {
  transition: all 0.3s ease;
}

.member-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

</style>
